import React from 'react';
import { Box, Button, Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { ff } from '../../../theme';
import { formatBrandList } from '../utils';

type Props = {
  brands: string[];
  onDismiss: () => void;
};

/**
 * Quiet nudge shown when the creator's worked-with brands don't match any active bounty —
 * tapping a brand pre-fills the propose flow with it.
 */
const WorkedWithCard: React.FC<Props> = ({ brands, onDismiss }) => {
  const navigate = useNavigate();
  const shown = brands.slice(0, 3);

  return (
    <Box position="relative" p="16px" pr="44px" borderRadius="18px" bg={ff.limeSurface}>
      <IconButton
        aria-label="Dismiss"
        icon={<Icon as={FiX} boxSize="14px" strokeWidth={2.6} />}
        variant="ghost"
        position="absolute"
        top={0}
        right={0}
        w="44px"
        h="44px"
        minW="44px"
        borderRadius="full"
        color="#55555A"
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        onClick={onDismiss}
      />
      <Text fontSize="15px" fontWeight={600} lineHeight="1.35" color={ff.ink}>
        Looks like you&apos;ve worked with {formatBrandList(brands)} before — want to propose a bounty?
      </Text>
      <Flex mt="10px" gap="8px" wrap="wrap">
        {shown.map((brand, i) => (
          <Button
            key={brand}
            h="44px"
            px="14px"
            borderRadius="full"
            fontSize="13px"
            fontWeight={600}
            bg={i === 0 ? ff.ink : 'white'}
            color={i === 0 ? ff.lime : ff.ink}
            _hover={{ bg: i === 0 ? ff.inkSoft : ff.grey }}
            _active={{ bg: i === 0 ? ff.inkSoft : ff.grey }}
            aria-label={`Propose a bounty for ${brand}`}
            onClick={() => navigate(`/bounties/propose?company=${encodeURIComponent(brand)}`)}
          >
            {brand}
          </Button>
        ))}
      </Flex>
    </Box>
  );
};

export default WorkedWithCard;
